import React, { useEffect, useReducer, useState } from 'react';
import GameManager from '../cvp-webgames-core/GameManager';

import UIOverlay from '../components/UIOverlay';
import ReactTools from '../cvp-webgames-core/Misc/ReactTools';
import VideoEnvironment from '../cvp-webgames-core/Components/Environments/React/VideoEnvironment';
//import Scenario1, {Scenario3, Scenario4, Scenario5, Scenario6, Scenario7, Scenario8, Scenario9, Scenario10, Scenario11, Scenario12} from '../scenarios/scenario1/Scenario1';
import { constants } from '../misc/constants';
import JsxUIManager from '../cvp-webgames-core/UI/JsxUiManager';
import ReactSoundManager from '../cvp-webgames-core/Sound/ReactSoundManager';
import { ScenariosConfig } from '../misc/interfaces';
import { getSaveData, mapDivEnterToClick, saveGame, Windows } from '../misc/tools';
import { globals } from '../misc/globals';
import NathanielClarke from '../scenarios/nathaniel-clarke/NathanielClarke';
import JavierMcBride from '../scenarios/javier-mcbride/JavierMcBride';
import DamonJones from '../scenarios/damon-jones/DamonJones';
import AndreGarza from '../scenarios/andre-garza/AndreGarza';
import GuadalupeHerrera from '../scenarios/guadalupe-herrera/GuadalupeHerrera';
import DarnellKennedy from '../scenarios/darnell-kennedy/DarnellKennedy';
import FaithAlvarado from '../scenarios/faith-alvarado/FaithAlvarado';
import EmanuelMcKenzie from '../scenarios/emanuel-mckenzie/EmanuelMcKenzie';
import RuthMcKenzie from '../scenarios/ruth-mckenzie/RuthMcKenzie';
import LeroyRobinson from '../scenarios/leroy-robinson/LeroyRobinson';
import WilliamHoward from '../scenarios/william-howard/WilliamHoward';
import AngelaScott from '../scenarios/angela-scott/AngelaScott';

const MuteBttn = (props: any) => { 
	const [forceUpdate, setForceUpdate] = useState(false);
	return (
		<div  style={{
			width: '5%',
			position: 'absolute',
			top: '33%',
			right: '0%',
			cursor: 'pointer',
			zIndex: 10
		}}
			tabIndex={0} 
			role='button' 
			aria-label={`Turn muting of audio ` + (globals.isMuted ? 'off' : 'on')} 
			id='mute-bttn' 
			onClick={() => {
				globals.isMuted = !globals.isMuted;
				props.onClick();
				setForceUpdate(!forceUpdate);

			}}>
			<img className="pointer modal-disable-select" src={globals.isMuted ? './assets/images/audioOff.svg' : './assets/images/audioOn.svg'} />
		</div>
	);
};


const reducer = (state: any, action: any) => {
	var result = ReactTools.generalReducer(state, action);
	switch (action.type) {
		case 'hideAllUIs':
			result = {...state, hideAllUIs: true};
			break; 
		case 'setGameManager':
			result = {...state, gameManager: action.value};
			break; 
		}
	return result;
};
 
const GamePage = (props: any) => { 
	// const [forceUpdate, setForceUpdate] = useState(false);
	const [state, dispatch] = useReducer(reducer, {
		gameManager: null,
		forceUpdate: true,
		hideAllUIs: false
	});

	(window as any).forceUpdateCC = () => {
		if((window as any).forceUpdateInternalCCComp) {
			(window as any).forceUpdateInternalCCComp();
		}
	}

    (window as any).onToggleMute = () => {
        globals.isMuted = !globals.isMuted;
        state.gameManager.SoundManager.mutedAudio = globals.isMuted;
        state.gameManager.environment.props.muted = globals.isMuted;
		(window as any)['muted-audio'] = globals.isMuted;
		if((window as any).onSetMute) {
			(window as any).onSetMute(globals.isMuted)
		}
        dispatch({
            type: 'forceUpdate'
        });
    }

    (window as any).isMuted = () => {
        return globals.isMuted;
    }

    (window as any).mapDivEnterToClick = (evt: any) => {
        return mapDivEnterToClick(evt);
    }

	useEffect(() => {
		if(state.gameManager) {
			if(typeof state.gameManager.currentScenarioIndex === 'undefined' || state.gameManager.currentScenarioIndex === null || state.gameManager.currentScenarioIndex === -1) {
				state.gameManager.loadScenario(props.scenarioId);
			}

		} else {
			var gm = new GameManager();
			
			gm.customData = {
				dispatch: dispatch,
				saveData: getSaveData(),
				updateWindow: props.updateWindow,
				saveGame: (gm: GameManager) => {
					saveGame(gm.customData.saveData);
				}
			};
			var environment = new VideoEnvironment(gm, dispatch);
			environment.init();
			gm.init([
				new NathanielClarke(gm, Windows.NathanielClarke.toString()),
				new JavierMcBride(gm, Windows.JavierMcBride.toString()),
				new DamonJones(gm, Windows.DamonJones.toString()),
				new AndreGarza(gm, Windows.AndreGarza.toString()),
				new GuadalupeHerrera(gm, Windows.GuadalupeHerrera.toString()),
				new DarnellKennedy(gm, Windows.DarnellKennedy.toString()),
				new FaithAlvarado(gm, Windows.FaithAlvarado.toString()),
				new EmanuelMcKenzie(gm, Windows.EmanuelMcKenzie.toString()),
				new RuthMcKenzie(gm, Windows.RuthMcKenzie.toString()),
				new LeroyRobinson(gm, Windows.LeroyRobinson.toString()),
				new WilliamHoward(gm, Windows.WilliamHoward.toString()),
				new AngelaScott(gm, Windows.AngelaScott.toString()),
			], environment, new JsxUIManager(gm), new ReactSoundManager(), true, '', {}, () => {
				// dispatch({
				// 	type: 'forceUpdate',
				// 	value: state.gameManager
				// });
			});
			dispatch({
				type: 'setGameManager',
				value: gm
			});
		}
	}, [state.gameManager]);
	
	// }, [state.gameManager, state.forceUpdate]);
  
	return (
		state.gameManager ? (
			<div id="game-container" style={{
				width: '100%',
				height: '100%'
			}}>
				{state.gameManager.environment.render((memory: string) => {
                    globals.memory = memory;

                    dispatch({
                        type: 'forceUpdate'
                    });
                }, () => {
					dispatch({
						type: 'forceUpdate'
					});
				}, {updateWindow: props.updateWindow, shouldShowDebugBttns: () => {
					return globals.showDebugForComponents;
				}})}
				{/* <MuteBttn onClick={() => {
					state.gameManager.SoundManager.mutedAudio = globals.isMuted;
					state.gameManager.environment.props.muted = globals.isMuted;
					state.gameManager.SoundManager.mutedAudio = globals.isMuted;
					state.gameManager.environment.mutedAudio = globals.isMuted;


				}}>

				</MuteBttn> */}
				<UIOverlay updateWindow={props.updateWindow} gameManager={state.gameManager} scenarioId={props.scenarioId} forceUpdate={() => {
					dispatch({
						type: 'forceUpdate',
						value: state.gameManager
					});
				}} hideAllUIs={state.hideAllUIs}></UIOverlay>
			</div>) : (<div>Initialing Page...</div>)
	);
};



export default GamePage;
